import { useState } from 'react'
import { X, Wrench, ShieldAlert, PackageX, Siren, AlertOctagon, Loader2 } from 'lucide-react'
import toast from 'react-hot-toast'
import { kioskApi } from './kiosk-api'

const CATEGORIAS = [
  { codigo: 'manutencao', nome: 'Manutenção', icon: Wrench, cor: 'bg-red-600 hover:bg-red-700' },
  { codigo: 'qualidade', nome: 'Qualidade', icon: ShieldAlert, cor: 'bg-amber-600 hover:bg-amber-700' },
  { codigo: 'falta_mp', nome: 'Falta de MP', icon: PackageX, cor: 'bg-blue-600 hover:bg-blue-700' },
  { codigo: 'seguranca', nome: 'Segurança', icon: Siren, cor: 'bg-rose-700 hover:bg-rose-800' },
  { codigo: 'outro', nome: 'Outro', icon: AlertOctagon, cor: 'bg-ink-600 hover:bg-ink-700' },
]

export default function KioskSOS({ etapa_op_id, onClose, onDone }: {
  etapa_op_id: number | null; onClose: () => void; onDone: () => void
}) {
  const [obs, setObs] = useState('')
  const [loading, setLoading] = useState(false)

  async function chamar(categoria: string) {
    setLoading(true)
    try {
      await kioskApi.post('/kiosk/sos', {
        categoria, etapa_op_id: etapa_op_id || undefined,
        observacao: obs || undefined,
      })
      toast.success('Chamado enviado — alguém virá ajudar')
      onDone()
    } catch (e: any) {
      toast.error(e?.response?.data?.detail || 'Erro')
    } finally { setLoading(false) }
  }

  return (
    <div className="fixed inset-0 bg-black/60 z-50 flex items-end md:items-center justify-center">
      <div className="bg-white w-full md:max-w-lg rounded-t-2xl md:rounded-2xl p-5 space-y-4 max-h-[95vh] overflow-y-auto">
        <div className="flex items-start justify-between">
          <h2 className="text-2xl font-bold flex items-center gap-2 text-rose-700">
            <Siren className="h-6 w-6" /> Chamar SOS
          </h2>
          <button onClick={onClose}><X className="h-6 w-6" /></button>
        </div>

        <p className="text-sm text-ink-600">Selecione o motivo. Notificação em tempo real será enviada ao painel andon.</p>

        <input
          value={obs}
          onChange={(e) => setObs(e.target.value)}
          placeholder="Detalhes (opcional)"
          className="w-full h-12 px-4 border-2 border-ink-200 rounded-xl"
        />

        <div className="grid grid-cols-1 gap-3">
          {CATEGORIAS.map(c => (
            <button
              key={c.codigo}
              onClick={() => chamar(c.codigo)}
              disabled={loading}
              className={`h-16 rounded-xl text-white font-bold text-lg flex items-center justify-center gap-3 disabled:opacity-40 ${c.cor}`}
            >
              {loading ? <Loader2 className="h-6 w-6 animate-spin" /> : <c.icon className="h-6 w-6" />}
              {c.nome}
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}
